import { Component, Injector } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { EmailBuilderService, FirebaseFunctionsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TCustomer, TEmail } from '@shared/models';

@Component({
    'selector': 'app-tests',
    'templateUrl': './tests.page.html',
    'styleUrls': ['./tests.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class TestsPage extends ViewBasePage {
    constructor(private emailBuilderService: EmailBuilderService, injector: Injector) {
        super(injector);
    }

    public async onEmailClick() {
        const subject = 'From the Backend';

        this.emailBuilderService.initializeEmailBody();
        this.emailBuilderService.setTitle(subject);
        this.emailBuilderService.addRow('This is the body of a very long email.');
        this.emailBuilderService.finalizeEmailBody();

        const htmlBody = this.emailBuilderService.getHtml();
        // console.log(htmlBody);
        const email: TEmail = {
            'subject': subject,
            'to': 'OneMinuteSystems@gmail.com',
            'htmlBody': htmlBody
        }

        await this.firebaseFunctionsService.sendEmail(email);
        await this.uxHelperService.showAlert('Email Test', 'Email has been sent to OneMinuteSystems@gmail.com');
    }

    public async onSmsClick() {
        const msg = 'This is a test message from ShuttleNomix backend at ' +
            this.dateService.formatTimestamp(this.dateService.now());

        const customer: TCustomer = {
            'customerName': 'Michael David Carr',
            'cellPhone': '6618778631',
            'shuttleDates': [],
            'uid': '',
        };
        // const data = { 'customers': [customer], 'debug': '**' + status.sequenceNo + '**' };
        const data = { 'customers': [customer] };
        
        await this.firebaseFunctionsService.sendSms([customer], 'smsTest', msg);
        await this.uxHelperService.showAlert('SMS Test', 'SMS has been sent to Michael.');
    }
    
    // Important!  If onErrorClick is clicked more than once, only the first
    // error will be saved to firestore.  So to thouroughly test this click
    // it twice and see if there is only one entry in the database.
    public async onErrorClick() {
        const now = this.dateService.now();
        const errorDatetime = this.dateService.formatTimestamp(now);
        const errMsg = 'Something bad happened at ' + errorDatetime;

        const msg = '1) An error will be thrown when the OK button clicked. ' +
            '2) Verify an error stored in the Firestore errors collection. ' + errorDatetime +
            '3) Verify that an email was sent to support@ShuttleNomix.com.';
        // await this.uxHelperService.showAlert('Error Test', msg);

        const response = await this.uxHelperService.showAlert('Error Test', msg);
        if (response.okay) {
            throw new Error(errMsg);
        }
    }

    public onRewardFunnelTestsClick(): void {
        this.router.navigateByUrl('/tests/rewardFunnelTests')
    }

    // private async onActiveCampaignAddTagsClick() {
    //     // const accountNumber = '00000-0000-00000';
    //     const email = 'Michael@ShuttleNomix.com';

    //     // tslint:disable-next-line: no-unused-expression
    //     const tagsToAdd: string[] = ['prospect', 'shuttles'];
    //     // const deltaTags = await this.firebaseFunctionsService.adjustActiveCampaignTags(email, tagsToAdd, []);
    //     // await this.firebaseFunctionsService.adjustActiveCampaignTags(email, tagsToAdd, []);
    // }

    // private async onActiveCampaignDeleteTagsClick() {
    //     // const accountNumber = '00000-0000-00000';
    //     const email = 'Michael@ShuttleNomix.com';

    //     // tslint:disable-next-line: no-unused-expression
    //     const tagsToDelete: string[] = ['shuttles'];
    //     // const deltaTags = await this.firebaseFunctionsService.adjustActiveCampaignTags(email, [], tagsToDelete);
    //     // await this.firebaseFunctionsService.adjustActiveCampaignTags(email, [], tagsToDelete);
    // }
}
